import Vue from "vue";
const title = Vue.directive("title", {
  inserted(el, binding) {
    document.title = el.dataset.title;
  }
});
export { title };



// WEBPACK FOOTER //
// ./src/components/directives/directive.js